import { APIClient } from '../../helpers/api_helper';

const AxiosClient = new APIClient()
const documentList = (payload) => AxiosClient.get('/document', payload);
const documentListForProject = (payload) => AxiosClient.get('/project-document', payload);
const storeDocument = (data) => AxiosClient.post('/document', data);
const deleteDocument = (documentId) => AxiosClient.delete(`/document/${documentId}`);
const uploadFile = (payload) => AxiosClient.post(`/upload-files`, payload);
const uploadLogo = (payload) => AxiosClient.post(`/upload-logo`, payload);
const getDownloadableLink = (documentId) => AxiosClient.get(`/document/${documentId}/download`);

export {
    documentList,
    storeDocument,
    deleteDocument,
    uploadFile,
    uploadLogo,
    documentListForProject,
    getDownloadableLink
}